import React, {useContext, useEffect} from 'react';
export const FAQView = (props) => {
    return (
        <iframe className='faqDocDiv' src="https://webtotality-my.sharepoint.com/personal/jefft_webtotality_com/_layouts/15/Doc.aspx?sourcedoc={cbef6e06-d253-49d7-850a-7935701dee6d}&amp;action=embedview&amp;wdEmbedCode=0" width="100%" height="100%" frameborder="0">This is an embedded <a target="_blank" href="https://office.com">Microsoft Office</a> document, powered by <a target="_blank" href="https://office.com/webapps">Office</a>.</iframe>
    );
}